// Vite embeds this value at build time. Azure builds either specify the public
// API origin or use a same-origin /api route configured in Front Door.
// Never fall back to the visitor's PC in a production build.
export const API_BASE_URL = (
  import.meta.env.VITE_API_URL?.trim() ??
  (import.meta.env.DEV ? "http://localhost:8000" : "")
).replace(/\/+$/, "");

export const API_PREFIX = "/api/v1";
